import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { FaStar } from "react-icons/fa";
import { IoIosInformationCircleOutline } from "react-icons/io";
// import Nearby from '../components/Nearby';
import Recommend from '../components/Recommend';
import { useDispatch, useSelector } from 'react-redux';
import GoogleMapContent, { getLocationInfo } from '../services/GoogleMapContent';
import {
  fetchItem, fetchTickets,
  setSelectedDate, setSelectedPersonType,
  selectItem, selectFilteredTickets, selectRate,
  selectPersonOptions, selectSelectedDate, selectSelectedPersonType
} from '../redux/slices/ticketSlice';

const ItemPageWrapper = styled.div `
  width: 100%;
  background: white;
`;

const ItemHeader = styled.div`
  width: 100%;
  position: relative;
`;

const BackButton = styled.button`
  width: 100%;
  background: #F0F3F5;
  border: none;
  padding: 13px;
  text-align: center;
  color: #079;
  font-size: 14px;
  font-weight: 500;
`;

const ItemImg = styled.div`
  width: 100%;
  aspect-ratio: 10/6;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;


const SlideCounter = styled.div`
  position: absolute;
  bottom: 10px;
  right: 15px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 5px 10px;
`;

const ItemContent = styled.div`
  margin: 10px 20px;
`;

const PageDesc = styled.div`
  color: #5B5B5B;
  font-size: 10px;
  font-weight: 400;
`;

const ItemInfo = styled.div`
  .title {
    margin: 5px 0 3px;
    font-size: 16px;
    font-weight: bold;
  }

  .location {
    font-size: 11px;
  }

  .rate {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 3px;
    margin: 10px 0;
    font-size: 12px;
    font-weight: 300;

    .score {
      display: flex;
      flex-direction: row;
      gap: 3px;
      color: #1B56ED;

      .tempInfo {
        color: gray;
      }
    }

    .sum {
      color: #818181;
    }
  }

  .detail {
    
  }
`;

const ItemDescription = styled.div`
  background: #F0F3F5;
  margin: 20px 0;
  border: solid 1px #282828;
  border-radius: 10px;
  padding: 10px 15px;
  font-size: 15px;
`;

const ItemOptions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: center;
  margin: 10px 0;

  input {
    appearance: none;
    background: #F0F3F5;
    border: none;
    border-radius: 5px;
    padding: 8px 100px;
    font-size: 14px;
    text-align: center;
    color: #282828;
    cursor: pointer;
    margin-bottom: 10px;
  }

  select {
    appearance: none;
    background: #F0F3F5;
    border: none;
    border-radius: 5px;
    padding: 8px 0px;
    font-size: 14px;
    text-align: center;
    text-align-last: center;
    color: #282828;
    cursor: pointer;
    margin-bottom: 10px;
  }

  button {
    background: #1B56ED;
    border: none;
    border-radius: 5px;
    padding: 8px 0;
    color: #FFF;
    cursor: pointer;
  }
`;

const ItemTickets = styled.div`
  width: 100%;
`;

const CompareTicket = styled.div`
  margin: 10px 0;
  border: 1px solid #DDD;
  border-radius: 10px;

  .title {
    background: #F9FAFB;
    padding: 10px;
    border-bottom: 1px solid #DDD;
    font-size: 13px;
    font-weight: bold;
  }

  .ticket {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 25px;
    border-bottom: 1px solid #DDD;
    padding: 10px;

    &:last-child {
      border-bottom: none;
    }

    div {
      flex: 1.0;
      text-align: left;
      font-size: 14px;
    }

    img {
      max-height: 15px;
    }

    button {
      background: #1B56ED;
      border: none;
      border-radius: 5px;
      padding: 5px 10px;
      color: #FFF;
      text-align: center;
    }
  }
`;

const ItemLocation = styled.div`
  margin-top: 30px;
  border-top: solid 2px #5C5C5C;
  border-bottom: solid 2px #5C5C5C;
  padding: 5px 0;

  .title {
    font-size: 16px;
    font-weight: bold;
  }

  .google-map {
    width: 100%;
    margin: 20px 0;

    #map {
      width: 100%;
      height: 300px;
      color: white;
    }

    .address {
      font-size: 12px;
      font-weight: lighter;
    }
  }

  .moreInfo {
    ul {
      list-style: none;
      padding: 0;
      margin: 10px 0;
    }

    li {
      font-size: 12px;
      margin-bottom: 7px;
    }

    h5 {
      margin-bottom: 10px;
      font-weight: bold;
    }
  }

`;

const ItemRate = styled.div`
  margin-top: 20px; // 30px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .description {
    margin-bottom: 20px;
    color: gray;
    font-size: 14px;
    font-weight: 100;
  }
`;

const RatingHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  .rate {
    width: 32%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .score {
      font-size: 36px;
      font-weight: bold;
      color:rgb(15, 13, 7);
    }

    .stars {
      display: flex;
      align-items: center;
      color: #fbc02d;
    }
  }
`;

const RatingBreakdown = styled.div`
  width: 65%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;

  .breakdown-item {
    display: flex;
    align-items: center;
    gap: 10px;

    .label {
      flex: 0.5;
    }

    .bar-container {
      flex: 10;
      position: relative;
      height: 6px;
      background: #eee;
      overflow: hidden;
    }

    .bar {
      height: 100%;
      background: #fbc02d;
      border-radius: 5px;
    }

    .value {
      flex: 1;
      text-align: right;
    }
  }
`;

const SummaryWrapper = styled.div`
  margin: 10px 0;
    
  .title {
    margin: 20px 0;
    font-size: 16px;
    font-weight: bold;
  }
`;


const SummaryTabs = styled.div`
  display: flex;
  margin-top: 10px;
  border-radius: 10px 10px 0 0;
  background: #D9D9D9;

  button {
    background: transparent;
    flex: 1;
    border: none;
    border-radius: 10px 10px 0 0;
    padding: 10px;
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;

    &.active {
      background: white;
      border: solid 2.5px #E8E8E8;
      border-bottom: none;
    }
  }
`;

const SummaryContent = styled.div`
  border-bottom: solid 1.5px #D9D9D9;
  padding: 0 5px;
  font-size: 14px;
`;

function ItemPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const item = useSelector(selectItem);
  const tickets = useSelector(selectFilteredTickets);
  const personOptions = useSelector(selectPersonOptions);
  const selectedDateFromRedux = useSelector(selectSelectedDate);
  const selectedPersonTypeFromRedux = useSelector(selectSelectedPersonType);
  const rate = useSelector(selectRate);
  const loading = useSelector((state) => state.tickets.loading);
  const error = useSelector((state) => state.tickets.error);

  const [localSelectedDate, setLocalSelectedDate] = useState(selectedDateFromRedux);
  const [localSelectedPersonType, setLocalSelectedPersonType] = useState(selectedPersonTypeFromRedux);
  
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeTab, setActiveTab] = useState("high");
  const [location, setLocation] = useState(null);

  // GetItem
  useEffect(() => {
    dispatch(fetchItem(id));
  }, [dispatch, id]);

  // GetItemTickets
  useEffect(() => {
    dispatch(fetchTickets({ id, selectedDate: selectedDateFromRedux }));
  }, [dispatch, id, selectedDateFromRedux]);

  // update 버튼 누르면 설정 날짜 등 변경
  useEffect(() => {
    setLocalSelectedDate(selectedDateFromRedux);
    setLocalSelectedPersonType(selectedPersonTypeFromRedux);
  }, [selectedDateFromRedux, selectedPersonTypeFromRedux]);

  useEffect(() => {
    if (item && item.region) {
      const address = `${item.region.street}, ${item.region.city}, ${item.region.state}, ${item.region.country}`;

      getLocationInfo(address).then((response) => {
        if (response) {
          setLocation(response);
        }
      }).catch(error => {
        console.error("Error fetching location info:", error);
        setLocation(null);
      });
    }
  }, [item]);

  const getPlatformImage = (platformName) => {
    const platformImages = {
      "booking.com": "/assets/Logo/Bookingcom.png",
      "trip.com": "/assets/Logo/Tripcom.png",
      "klook": "/assets/Logo/Klook.jpg",
      "tiqets": "/assets/Logo/Tiqets.jpg",
      "viator": "/assets/Logo/Viator.jpg"
    };
  
    return platformImages[platformName.toLowerCase()] || null;
  };

  const handleDateChange = (e) => {
    setLocalSelectedDate(e.target.value);
  };

  const handlePersonTypeChange = (e) => {
    setLocalSelectedPersonType(e.target.value);
  };

  const handleSearchClick = () => {
    dispatch(setSelectedDate(localSelectedDate));
    dispatch(setSelectedPersonType(localSelectedPersonType));
    dispatch(fetchTickets({ id, selectedDate: localSelectedDate }));
  };

  const filteredTickets = selectedPersonTypeFromRedux === "all"
  ? tickets
  : Object.fromEntries(
      Object.entries(tickets)
        .map(([ticketType, personTypes]) => {
          if (!personTypes[selectedPersonTypeFromRedux]) {
            return null;
          }
          return [
            ticketType,
            { [selectedPersonTypeFromRedux]: personTypes[selectedPersonTypeFromRedux] }
          ];
        })
        .filter(Boolean)
    );

  const ratingLabels = ["5", "4", "3", "2", "1"];

  const sliderSettings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    vertical: false,
    afterChange: (current) => setCurrentSlide(current),
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!item) return <p>No data available</p>;

  return (
    <>
      <Helmet>
        <title>MusePicker</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta name="author" content="MusePicker" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": item.name,
            "description": item.description,
            "offers": {
              "@type": "AggregateOffer",
              "lowPrice": item.lowestPrice,
              "priceCurrency": "USD",
              "offerCount": item.totalCount
            }
          })}
        </script>
      </Helmet>

      <ItemPageWrapper>
        <ItemHeader>
          <BackButton onClick={() => navigate(-1)}>← See other tickets</BackButton>
          {(!item.images || item.images.length === 0) ? (
            // 이미지 없음 -> 기본 이미지
            <ItemImg>
              <img src="/assets/temp.jpg" alt="Item pic" />
            </ItemImg>
          ) : item.images.length === 1 ? (
            // 이미지 1개 -> 슬라이더 없이
            <ItemImg>
              <img src={item.images[0]} alt="Item pic" />
            </ItemImg>
          ) : (
            // 이미지 2개 이상 -> 슬라이더 사용
            <Slider {...sliderSettings}>
              {item.images.map((src, index) => (
                <ItemImg key={index}>
                  <img src={src} alt="Item pic" />
                </ItemImg>
              ))}
            </Slider>
          )}
          <SlideCounter>
            {currentSlide + 1} / {item.images.length}
          </SlideCounter>
        </ItemHeader>
        <ItemContent>
        <PageDesc>Home &gt; {item.region.city} &gt; {item.categories.join(", ")}</PageDesc>
          <ItemInfo>
            <div className='title'>{item.name}</div>
            <div className='location'>{item.region.street}, {item.region.city}, {item.region.state}, {item.region.country}</div>
            <div className='rate'>
              <div className='score'><FaStar size={12}/> {rate?.rating || "N/A"}</div>
              <div className='sum'>({rate?.rating_count || "0"})</div>
              {/* <div className='score'>
                <FaStar size={12}/>
                <IoIosInformationCircleOutline color='gray' size={12}/>
                <div className='tempInfo'>We are currently preparing to introduce a rating system.</div>
              </div> */}
            </div>
            <ItemDescription>{item.description}</ItemDescription>
          </ItemInfo>
          <ItemOptions>
            <input type="date" className="option"
              value={localSelectedDate}
              onChange={handleDateChange}
            />
            <select className="option"
              value={localSelectedPersonType}
              onChange={handlePersonTypeChange}
            >
              {personOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <button  onClick={handleSearchClick}>🔍 Search</button>
          </ItemOptions>
          <ItemTickets>
            {Object.keys(filteredTickets).length > 0 ? (
              Object.entries(filteredTickets).map(([ticketType, personTypes]) => (
                Object.entries(personTypes).map(([personType, platforms]) => (
                  <CompareTicket key={`${ticketType}-${personType}`}>
                    <div className='title'>{ticketType} - {personType}</div>
                    {Object.entries(platforms || {})
                      .sort(([, a], [, b]) => a.price - b.price)
                      .map(([platform, { price, url }]) => (
                        <div className="ticket" key={platform}>
                          <div>
                            {getPlatformImage(platform) ? (
                              <img src={getPlatformImage(platform)} alt={platform} />
                            ) : (
                              platform
                            )}
                          </div>
                          <div></div>
                          <div>${price ? price.toFixed(2) : "N/A"}</div>
                          <div>
                            <button onClick={() => window.open(url, "_blank")}>View deal</button>
                          </div>
                        </div>
                      ))}
                  </CompareTicket>
                ))
              ))
            ) : (
              <div>No tickets available for the selected options.</div>
            )}
          </ItemTickets>

          <ItemLocation>
            <div className='title'>Location</div>
            <div className='google-map'>
              <div id="map">
                { location ? (
                  <GoogleMapContent lat={location.location.lat} lng={location.location.lng} />
                ) : (
                  <GoogleMapContent lat={null} lng={null} />
                )}
              </div>
              <div className="address">{item.region.street}, {item.region.city}, {item.region.state}, {item.region.country}</div>
            </div>
            <div className="moreInfo">
              <h5>What's nearby</h5>
              <ul>
                { location && location.nearbyPlaces && Array.isArray(location.nearbyPlaces.place) ? (
                  location.nearbyPlaces.place.map((place, index) => (
                    <li key={index}>
                      {place.destination} - <strong>{place.distance}, {place.duration}</strong>
                    </li>
                  ))
                ):(
                  <p>Loading nearby places...</p> // none
                )}
              </ul>
            </div>
          </ItemLocation>
          <ItemRate>
            <div className='description'>
              <IoIosInformationCircleOutline size={18}/> &nbsp;
              Sorry, we are currently preparing to introduce a rating system. You can check the ratings and reviews for this product here.
            </div>
            <RatingHeader>
              <div className='rate'>
                <div className="score">
                  {rate?.rating && !isNaN(parseFloat(rate.rating))
                    ? parseFloat(rate.rating).toFixed(1)
                    : "N/A"}
                  </div>
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} style={{ color: i < Math.round(rate.rating) ? "#fbc02d" : "#ddd" }} />
                    // <FaStar key={i} style={{ color: i < Math.round(4) ? "#fbc02d" : "#ddd" }} />
                  ))}
                </div>
              </div>
              <RatingBreakdown>
                {/* {item.rate.score_detail.map((count, index) => { */}
                {[0,0,0,0,0].map((count, index) => {
                  const percentage = (count / 1) * 100;
                  return (
                    <div className="breakdown-item" key={index}>
                      <span className="label">{ratingLabels[index]}</span>
                      <div className="bar-container">
                        <div className="bar" style={{ width: `${percentage}%` }}></div>
                      </div>
                      <span className="value">({count})</span>
                    </div>
                  );
                })}
              </RatingBreakdown>
            </RatingHeader>
            <SummaryWrapper>
              <div className="title">✨ Guests Say,</div>
              <SummaryTabs>
                <button
                  className={activeTab === "high" ? "active" : ""}
                  onClick={() => setActiveTab("high")}
                >
                  High Rating Summary
                </button>
                <button
                  className={activeTab === "low" ? "active" : ""}
                  onClick={() => setActiveTab("low")}
                >
                  Low Rating Summary
                </button>
              </SummaryTabs>
              <SummaryContent>
                {/* {activeTab === "high" ? (
                  <p>{item.rate.high}</p>
                ) : (
                  <p>{item.rate.low}</p>
                )} */}
                <p>We are currently in preparation.</p>
              </SummaryContent>
            </SummaryWrapper>
          </ItemRate>
        </ItemContent>
        {/* <Nearby /> nearby 관련 api 없음 */}
        <Recommend /> 
      </ItemPageWrapper>
    </>
  );
}

export default ItemPage;